import { translateFr as tfr } from "@/i18n";
export const RENEWAL_STATUS = {
  to_qualify: { label: tfr("À qualifier"), cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25", dot: "#9CA3AF" },
  preparing: { label: tfr("Préparation"), cls: "bg-blue-500/10 text-blue-400 border-blue-500/25", dot: "#3B82F6" },
  negotiation: { label: tfr("Négociation"), cls: "bg-amber-500/10 text-amber-400 border-amber-500/25", dot: "#F5A524" },
  agreement: { label: tfr("Accord de principe"), cls: "bg-violet-500/10 text-violet-400 border-violet-500/25", dot: "#8B5CF6" },
  signed: { label: tfr("Signé"), cls: "bg-green-500/10 text-green-400 border-green-500/25", dot: "#22C55E" },
  not_renewed: { label: tfr("Non renouvelé"), cls: "bg-zinc-500/10 text-zinc-500 border-zinc-500/20", dot: "#71717A" },
  lost: { label: "Perdu", cls: "bg-red-500/10 text-red-400 border-red-500/25", dot: "#E5484D" },
};
export const OPEN_RENEWAL_STATUSES = ["to_qualify", "preparing", "negotiation", "agreement"];
export const renewalStatusLabel = (id) => RENEWAL_STATUS[id]?.label || id;

export const RENEWAL_PRIORITY = {
  critical: { label: "Critique", cls: "bg-red-500/15 text-red-400 border-red-500/35" },
  high: { label: tfr("Élevée"), cls: "bg-orange-500/15 text-orange-400 border-orange-500/35" },
  normal: { label: "Normale", cls: "bg-blue-500/12 text-blue-400 border-blue-500/30" },
  low: { label: "Faible", cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25" },
};

export const RENEWAL_BUCKETS = [
  { id: "expired", label: tfr("Expirés"), tone: "text-red-400" },
  { id: "d30", label: "≤ 30 j", tone: "text-red-400" },
  { id: "d60", label: "31–60 j", tone: "text-orange-400" },
  { id: "d90", label: "61–90 j", tone: "text-amber-400" },
  { id: "d180", label: "91–180 j", tone: "text-blue-400" },
  { id: "d365", label: "181–365 j", tone: "text-zinc-400" },
];

export const RENEWAL_EVENT_TYPES = [
  { id: "note", label: "Note" },
  { id: "call", label: "Appel" },
  { id: "meeting", label: tfr("Réunion") },
  { id: "offer", label: "Proposition" },
  { id: "counter_offer", label: "Contre-proposition" },
];

export function daysLeftLabel(days, lang = "fr") {
  const en = lang === "en";
  if (days == null) return en ? "Unknown deadline" : "Échéance inconnue";
  if (days < 0) return en ? `Expired ${Math.abs(days)} d ago` : `Expiré depuis ${Math.abs(days)} j`;
  if (days === 0) return en ? "Expires today" : "Expire aujourd'hui";
  return en ? `Expires in ${days} d` : `Expire dans ${days} j`;
}

export function translateReason(reason, lang = "fr") {
  if (lang !== "en" || !reason) return reason;
  return reason
    .replace(/^Contrat expiré depuis (\d+) jours?$/, "Contract expired $1 day(s) ago")
    .replace(/^Le contrat expire dans (\d+) jours?$/, "Contract expires in $1 day(s)")
    .replace(/^Échéance à (\d+) jours?$/, "Due in $1 days")
    .replace(/^Action « (.+) » en retard de (\d+) jours?$/, 'Action "$1" overdue by $2 day(s)')
    .replace(/^Aucune prochaine action planifiée$/, "No next action planned")
    .replace(/^Aucune activité sur le dossier depuis (\d+) jours$/, "No activity on the case for $1 days")
    .replace(/^Dossier non qualifié à moins de 90 jours de l'échéance$/, "Case not qualified within 90 days of the deadline");
}
